import React from 'react'
import { useState, useEffect } from 'react';
import styles from './StartTutorial.scss';
import { useTranslation, } from 'react-i18next';
import { Check, Close } from 'jbc-front/components/icons';
import ListGroup from 'jbc-front/components/ListGroup';
import IntroduceGuide from '../../GuideTour/IntroduceGuide'
import StartGuide from '../../GuideTour/StartGuide'
import { useCookies } from 'react-cookie';
import styled, { ThemeProvider } from 'styled-components';
import { useTutorialContext } from '../../GuideTour/TutorialProvider';

const Row = styled.div`
    cursor: ${props => props.theme.onOpen ? 'default' : 'default !important'};
`
const ExampleGuide = ({ t }) => (
    <div>
        <p className={styles.mg13}>{t(`features.Dashbord.components.Tutorial.text`)}</p>
        <div className={styles.flow}>
            <div className={`${styles.checkbox} ${styles.complete}`}><Check size={7} /></div>
            <div className={`${styles.line} ${styles.greenLine}`}></div>

            <div className={`${styles.checkbox} ${styles.pending}`}></div>
            <div className={styles.line}></div>

            <div className={`${styles.checkbox}`}></div>
        </div>
        <div className={styles.list}>
            <div className={`${styles.row} ${styles.complete}`} id={'step-1'}>
                <div className={`${styles.checkbox} ${styles.complete}`}><Check size={7} /></div>
                <p>{t(`features.Dashbord.components.Setup.${STEP[0].text}`)}</p>
            </div>

            <div className={`${styles.row} ${styles.pending}`} id={'step-2'}>
                <div className={`${styles.checkbox}`}></div>
                <p>{t(`features.Dashbord.components.Setup.${STEP[1].text}`)}</p>
            </div>

            <div className={styles.row} id={'step-3'}>
                <div className={`${styles.checkbox}`}></div>
                <p>{t(`features.Dashbord.components.Setup.${STEP[2].text}`)}</p>
            </div>
        </div>
        <p className={styles.again} id={'show-again'}>{t(`features.Dashbord.components.Tutorial.show_again`)}</p>
    </div>
)
const STEP = [
    {
        name: "client_info",
        text: 'register_office',
        rowClassName: `${styles.row} ${styles.complete}`,
        rowCheckboxClassName: `${styles.checkbox} ${styles.complete}`,
        flowCheckboxClassName: `${styles.checkbox} ${styles.complete}`
    },
    {
        name: "payroll_rules_groups",
        text: 'salary_rules_setting',
        rowClassName: `${styles.row} ${styles.complete}`,
        rowCheckboxClassName: `${styles.checkbox} ${styles.complete}`,
        flowCheckboxClassName: `${styles.checkbox} ${styles.complete}`
    },
    {
        name: "employees",
        text: 'employee_setting',
        rowClassName: `${styles.row} ${styles.complete}`,
        rowCheckboxClassName: `${styles.checkbox} ${styles.complete}`,
        flowCheckboxClassName: `${styles.checkbox} ${styles.complete}`
    },
]

export default function StartTutorial({ notCompletedSetting, currentUser }) {
    const { setTutorialBox, setTutorialStep1, setTutorialStep2, addUser,
        setTutorialStep3, getAllTutorial } = useTutorialContext()

    const [onOpen, setOnOpen] = useState(false)
    const [onStart, setOnStart] = useState(false)
    const [onCompleteIntro, setOnCompleteIntro] = useState(false)
    const [step, setStep] = useState(STEP)
    const [cookies] = useCookies(['tutorial']);
    const [firstLine, setFirstLine] = useState(styles.line)
    const [secondLine, setSecondLine] = useState(styles.line)
    const [introTutorialBox, setIntroTutorialBox] = useState()
    const { t } = useTranslation()

    const setStateTutorialBox = () => {
        const allTutorial = getAllTutorial(currentUser.email)
        const { tutorialBox } = allTutorial
        setIntroTutorialBox(tutorialBox)
    }

    useEffect(() => {
        const allTutorial = getAllTutorial(currentUser.email)
        if (allTutorial) {
            const { tutorialBox } = allTutorial
            setIntroTutorialBox(tutorialBox)
        }
    }, [cookies['tutorial']])

    const handleClickOpen = () => {
        setOnOpen(true)
        if (introTutorialBox) {
            setTutorialBox({ onOpen: true, onStart: false, onCompleteIntro: false })

        }
        else
            setTimeout(() => {
                setTutorialBox({ onOpen: true, onStart: true, onCompleteIntro: false })

            }, 1000)
    }
    const handleClickClose = async () => {
        const { onStart, onCompleteIntro } = introTutorialBox
        setTutorialBox({ onOpen: false, onStart, onCompleteIntro })
    }
    const handleClickShowAgain = () => {
        setTutorialBox({ onOpen: true, onStart: true, onCompleteIntro: false })//.then(() => {
        setOnStart(true)
    }
    useEffect(() => {
        if (introTutorialBox) {
            setOnOpen(introTutorialBox.onOpen || false)
            setOnStart(introTutorialBox.onStart || false)
            setOnCompleteIntro(introTutorialBox.onCompleteIntro || false)
        }
    }, [introTutorialBox])

    useEffect(() => {
        addUser(currentUser.email)

        const step = STEP
        notCompletedSetting.map((e, index) => {
            var stepIndex = STEP.findIndex(ele => ele.name == e)
            if (index == 0) {
                step[stepIndex].rowClassName = `${styles.row} ${styles.pending}`
                step[stepIndex].rowCheckboxClassName = `${styles.checkbox}`
                step[stepIndex].flowCheckboxClassName = `${styles.checkbox} ${styles.pending}`

            } else {
                step[stepIndex].rowClassName = `${styles.row}`
                step[stepIndex].rowCheckboxClassName = `${styles.checkbox}`
                step[stepIndex].flowCheckboxClassName = `${styles.checkbox}`
            }
        })
        setStep(step)
        if (notCompletedSetting.length == 3) {

        }
        else if (notCompletedSetting.length == 2) {
            setFirstLine(`${styles.line} ${styles.blueLine}`)
        }
        else if (notCompletedSetting.length == 1) {
            setSecondLine(`${styles.line} ${styles.blueLine}`)
            setFirstLine(`${styles.line} ${styles.greenLine}`)
        }
    }, [])

    const onTutorialStart = (stepNo) => {
        if (stepNo === 0 ){
            setTutorialStep1({ run: true, stepIndex: 0, tourCompleted: false, type: 'edit' })
        }
        else if (stepNo === 1)
            setTutorialStep2({ run: true, stepIndex: 0, tourCompleted: false, type: 'create' })
        else if (stepNo === 2)
            setTutorialStep3({ run: true, stepIndex: 0, tourCompleted: false, type: 'setInfo' })
    }


    return (
        <React.Fragment>
            {!introTutorialBox && <StartGuide />}
            <IntroduceGuide onStart={onStart} notCompletedSetting={notCompletedSetting}
                onCompleteIntro={onCompleteIntro} setStateTutorialBox={setStateTutorialBox} />
            <div className={styles.box} style={{ opacity: onOpen ? 1 : 0, zIndex: onOpen ? 1 : 0 }}>
                <ListGroup>
                    <ListGroup.Title>
                        <p>{t(`features.Dashbord.components.Tutorial.title`)}</p>
                        <div className={styles.close}>
                            <Close onClick={handleClickClose} />
                        </div>
                    </ListGroup.Title>

                    <div className={styles.listItem} id={'tourList'}>
                        {onStart && !onCompleteIntro ? <ExampleGuide t={t} /> :
                            <div>
                                <p className={styles.mg13}>{t(`features.Dashbord.components.Tutorial.text`)}</p>
                                <div className={styles.flow}>
                                    <div className={step[0].flowCheckboxClassName}><Check size={7} /></div>
                                    <div className={firstLine}></div>
                                    <div className={step[1].flowCheckboxClassName}><Check size={7} /></div>
                                    <div className={secondLine}></div>
                                    <div className={step[2].flowCheckboxClassName}><Check size={7} /></div>
                                </div>
                                <ThemeProvider theme={{ onOpen: onOpen }}>
                                    <div className={styles.list}>
                                        {step.map((e, index) => (
                                            <Row className={e.rowClassName} key={index} id={`step-${index + 1}`} onClick={() => onTutorialStart(index)}>
                                                <div className={e.rowCheckboxClassName} ><Check size={7} /></div>
                                                <p>{t(`features.Dashbord.components.Setup.${e.text}`)}</p>
                                            </Row>
                                        ))}
                                    </div>
                                </ThemeProvider>
                                <p className={styles.again} id={'show-again'} onClick={handleClickShowAgain}>{t(`features.Dashbord.components.Tutorial.show_again`)}</p>
                            </div>
                        }
                    </div>
                </ListGroup>
            </div>
            <div className={styles.button} style={{ opacity: onOpen ? 0 : 1, zIndex: onOpen ? 0 : 1 }} onClick={handleClickOpen} id={'start-button'}>
                {t(`features.Dashbord.components.Tutorial.button`)}
            </div>
        </React.Fragment>
    )
}
